import {Model} from "ords/dist/model/model"

export class RubricForm extends  Model{
    hasResultForUser(user_id) {
        return this.rubric_form_results.some((result) => result.user_id === user_id);
    }

    getResultForUser(user_id) {
        return this.rubric_form_results.first((result) => result.user_id === user_id);
    }
}

export const RubricFormConfig = {
    name: 'rubricForm',
    model: RubricForm,
    relations: [
        {name: 'answers', model_name: 'rubricAnswer', type: 'hasMany'},
        {name: 'rubric_form_results', model_name: 'rubricFormResult', type: 'hasMany'},
    ]
}
